export const MAINTENANCE_CONFIG = {
  // Cambiar a false cuando se desee reactivar los formularios públicos
  enabled: true,
  title: 'Formulario en Mantenimiento',
  message: 'Estimado usuario: El formulario de solicitud de turnos se encuentra momentáneamente deshabilitado por tareas de mantenimiento y actualización en el sistema.',
  submessage: 'Por favor, intente nuevamente más tarde o comuníquese directamente con la recepción del consultorio para gestionar su atención. Disculpe las molestias ocasionadas.'
};
